import React from 'react';
import { useStore } from '../../store/store';
import styles from './Dashboard.module.scss';
import HeroHalf from './HeroHalf/HeroHalf';
// TODO: Re-enable when ProspectMetrics API is ready
// import ProspectMetrics from './ProspectMetrics/ProspectMetrics';
import QuickLinks from './QuickLinks/QuickLinks';

const Dashboard: React.FC = () => {
  const theme = useStore((state) => state.theme);

  return (
    <div className={styles.container}>
      <HeroHalf theme={theme} />
      {/* TODO: Re-enable when ProspectMetrics API is ready */}
      {/* <ProspectMetrics theme={theme} /> */}
      <QuickLinks theme={theme} />
    </div>
  );
};

export default Dashboard;
